import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Button } from 'builder/components/Button'
import Media from 'builder/styles/media'
import { Icon24 } from 'builder/components/Icon'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;

  ${Media.Tablet`
    padding-bottom: 24px;
  `};

  ${Media.Phone`
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 120px;
  `};
`

export const PlansRedesignRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  align-items: center;
`

export const PlansBenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 44px;
  margin-bottom: 41px;

  ${Media.Phone`
    padding-top: 0;
  `};
`

export const PlansBenefitsTitle = styled.h1`
  color: ${Colors.Neutral90};
  ${FontWeights.DemiBold};
  ${Typography.L};
  text-align: center;
  margin-bottom: 42px;

  ${Media.Tablet`
    margin-bottom: 108px;
  `};

  ${Media.Phone`
    font-size: 23px;
    margin-bottom: 16px;
  `};
`

export const PlansBenefitsScreen = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 16px;
    justify-content: center;
    align-items: flex-start;
  }
`

export const PlansBenefitsLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 402px;
  width: 100%;

  ${Media.Tablet`
    max-width: unset;
    padding: 0 ${Spacing.M};
  `};

  ${Media.Phone`
    padding: 0;
  `};
`

export const PlansBenefitsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 26px;
  justify-content: center;

  ${Media.Phone`
    flex-direction: column;
    gap: 20px;
    margin-bottom: ${Spacing['2XS']};
  `};
`

export const PricingOption = styled.div<{ $selected?: boolean }>`
  border: 2px solid ${props => (props.$selected ? Colors.Blue50 : Colors.Neutral15)};
  border-radius: 16px;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s ease;
  flex: 1;
  padding-top: 14px;
  padding-left: 16px;
  padding-bottom: 28px;

  &:hover {
    border-color: ${Colors.Blue50};
  }

  ${Media.Tablet`
    width: 192px;
    flex: unset;
  `};

  ${Media.Phone`
    padding: 16px;
    width: 100%;
    flex: 1;
  `};
`

export const RadioButton = styled.div<{ $selected?: boolean }>`
  width: 18px;
  height: 18px;
  border: 2px solid ${props => (props.$selected ? Colors.Blue50 : Colors.Neutral30)};
  border-radius: 50%;
  margin-right: 15px;
  position: relative;

  ${props =>
    props.$selected &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      background-color: ${Colors.Blue50};
      border-radius: 50%;
    }
  `}
`

export const PricingOptionContent = styled.div`
  display: flex;
`

export const PricingDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    flex-direction: row;
    width: 100%;
  `};
`

export const PricingPeriod = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const PricingAmount = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};

  ${Media.Phone`
    margin-left: auto;
  `};
`

export const DurationSuffix = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.Subhead};
  ${FontWeights.Medium};
`

export const PlanFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 42px;
  border: 1px solid ${Colors.Neutral15};
  border-radius: 16px;
  padding: ${Spacing.M};

  ${Media.Tablet`
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 16px;
  `};

  ${Media.Phone`
    flex-direction: column;
    margin-bottom: 32px;
  `};
`

export const PlanFeature = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  ${Media.Tablet`
    width: 48%;
  `};

  ${Media.Phone`
    width: 100%;
  `};
`

export const FeatureIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const PlanFeatureDescription = styled.span<{ $isHistoricalLeads?: boolean }>`
  color: ${props => (props.$isHistoricalLeads ? Colors.Neutral50 : Colors.Neutral90)};
  ${Typography.Caption};

  &.bold {
    color: ${Colors.Neutral90};
    ${props => (props.$isHistoricalLeads ? FontWeights.Medium : FontWeights.DemiBold)};
  }
`

export const ContinueButton = styled(Button)`
  width: 100%;
`

export const CancelAnytime = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral90};
  text-align: center;
  display: flex;
  gap: 4px;

  &.email {
    ${FontWeights.Medium};
    color: ${Colors.Blue50};
  }
`

export const MobileBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 32px;
  width: 100%;
  align-items: center;
`

export const MostPopularBadge = styled.div`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(94deg, #9ba1fb 0%, #4c89f3 47.53%, #54aff8 100%);
  color: white;
  ${Typography.Tiny};
  ${FontWeights.Bold};
  letter-spacing: 0.3px;
  padding: 4px 8px 4px 12px;
  border-radius: 4px;
  text-transform: uppercase;
  width: max-content;
  z-index: 1;
`

export const PeopleChoseBubble = styled.div`
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translate(-50%, -100%);
  background: ${Colors.Neutral90};
  color: white;
  ${Typography.Caption};
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(15, 20, 30, 0.16), 0px 8px 20px -4px rgba(15, 20, 30, 0.24);
  width: 170px;
  z-index: 2;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid ${Colors.Neutral90};
  }

  ${Media.Phone`
    display: none;
  `};
`

export const HeaderContainer = styled.div`
  position: absolute;
  left: 32px;

  ${Media.Tablet`
    left: 20px;
  `};

  ${Media.Phone`
    position: relative;
    margin-right: auto;
    margin-bottom: 20px;
  `};
`

export const CloseButton = styled(Icon24.Close)`
  position: absolute;
  right: 32px;
  width: 34px;
  height: 34px;
  cursor: pointer;
  color: ${Colors.Neutral30};

  ${Media.Tablet`
    right: 20px;
  `};
`
